import { models } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";

import { useRootContext } from "../../contexts/RootContext";
import "./styles.css";

type PowerBiProps = {
  reportId: string;
};

const PowerBi = ({ reportId }: PowerBiProps) => {
  const { idToken } = useRootContext();

  return (
    idToken && (
      <PowerBIEmbed
        embedConfig={{
          type: "report",
          id: reportId,
          accessToken: idToken,
          tokenType: models.TokenType.Embed,
          permissions: 0, // Read = 0, ReadWrite = 1, Copy = 2, Create = 4, All = 7
          settings: {
            panes: {
              filters: { visible: true, expanded: true },
            },
          },
        }}
        cssClassName={"reportClass"}
        getEmbeddedComponent={(embeddedReport) => {
          if (this) {
            // @ts-ignore
            this.report = embeddedReport as unknown as Report;
          }
        }}
      />
    )
  );
};

export default PowerBi;
